import React, { ReactElement, useState, useEffect } from "react";
import styled from "styled-components";
import { Button } from "./button";

const StyledBackgroundImageWrapper = styled.div`
  overflow-x:hidden;
  overflow-y:auto;
`;

const StyledBackground = styled.div`
  overflow-x:hidden;
  overflow-y:auto;
`;

const StyledBackgroundImage = styled.div<{src : string}>`
  background-image: url(${(props) => props.src});
  min-height: 100vh;
  width:100%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  z-index: -1;
`;

const StyledBackgroundButton = styled.div<{animate: boolean}>`
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 70%;
  transition: all 0.3s ease;
  opacity: 1 ;
  ${(props) =>
    props.animate && `
        opacity:0;
    `}
`;

interface BackgroundProps {
    src: string;
    placeholder?: string;
}


const Background = ({src, placeholder}: BackgroundProps): ReactElement => {
    const [toggle, setToggle] = useState(false)

    const handleScroll = () => {
        const position = window.scrollY;
        if(position > 70) {
            setToggle(true)
        }
        if(position <= 50){
            setToggle(false)
        }
    }

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
            window.removeEventListener('scroll', handleScroll);
		  };
	}, []);

    return <StyledBackground>
              <StyledBackgroundImageWrapper>
              <StyledBackgroundImage src={process.env.PUBLIC_URL + src}/>
              </StyledBackgroundImageWrapper>
              <StyledBackgroundButton animate={toggle}>
                  <Button to={""} main={true} value='contact'/>
              </StyledBackgroundButton>
          </StyledBackground>
}

export { Background }
